(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["curved-media-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('curved-media-hero')) {
    customElements.define(
      'curved-media-hero',
      class CurvedMediaHero extends HTMLElement {
        constructor() {
          super();
          this.onMuteClick = this.onMuteClick.bind(this);
          this.onMqChange = this.onMqChange.bind(this);
          this.onPrev = this.onPrev.bind(this);
          this.onNext = this.onNext.bind(this);
          this.onDot = this.onDot.bind(this);
          this.onBlockSelect = this.onBlockSelect.bind(this);
          this.onTouchStart = this.onTouchStart.bind(this);
          this.onTouchEnd = this.onTouchEnd.bind(this);
          this.onIntersect = this.onIntersect.bind(this);
          this.index = 0;
          this.touchX = 0;
          this.inView = true;
        }

        connectedCallback() {
          if (this.querySelector('[data-cmh-track]')) {
            this.init();
            return;
          }
          requestAnimationFrame(() => this.init());
        }

        init() {
          if (this.initialized) return;
          this.initialized = true;

          this.track = this.querySelector('.cmh__track');
          this.slides = this.querySelectorAll('[data-cmh-slide]');
          this.dots = this.querySelectorAll('[data-cmh-dot]');
          this.mq = window.matchMedia('(min-width: 769px)');
          this.autoplayMs = parseFloat(this.getAttribute('data-cmh-autoplay') || '0') * 1000;

          this.querySelectorAll('video').forEach((video, i) => this.prepareVideo(video, i));

          this.querySelectorAll('[data-cmh-mute]').forEach((btn) => {
            btn.addEventListener('click', this.onMuteClick);
          });
          this.querySelector('[data-cmh-prev]')?.addEventListener('click', this.onPrev);
          this.querySelector('[data-cmh-next]')?.addEventListener('click', this.onNext);
          this.dots.forEach((dot) => dot.addEventListener('click', this.onDot));
          this.addEventListener('touchstart', this.onTouchStart, { passive: true });
          this.addEventListener('touchend', this.onTouchEnd, { passive: true });

          if (this.mq.addEventListener) {
            this.mq.addEventListener('change', this.onMqChange);
          } else {
            this.mq.addListener(this.onMqChange);
          }

          document.addEventListener('shopify:block:select', this.onBlockSelect);

          if ('IntersectionObserver' in window) {
            this.io = new IntersectionObserver(this.onIntersect, { rootMargin: '200px 0px', threshold: 0.01 });
            this.io.observe(this);
          }

          this.goTo(0, true);
          this.startAutoplay();
        }

        disconnectedCallback() {
          this.stopAutoplay();
          if (this.io) this.io.disconnect();
          if (this.mq) {
            if (this.mq.removeEventListener) {
              this.mq.removeEventListener('change', this.onMqChange);
            } else {
              this.mq.removeListener(this.onMqChange);
            }
          }
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          this.initialized = false;
        }

        prepareVideo(video, index) {
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.loop = true;
          video.controls = false;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('autoplay', '');
          video.removeAttribute('loading');

          const token = (this.id || 'cmh') + '-' + index;
          const uniq = (value) => {
            if (!value) return value;
            try {
              const url = new URL(value, window.location.href);
              url.searchParams.set('cmh', token);
              return url.toString();
            } catch (err) {
              return value;
            }
          };

          video.querySelectorAll('source').forEach((source) => {
            const next = uniq(source.getAttribute('src'));
            if (next) source.setAttribute('src', next);
          });
          if (video.hasAttribute('src')) {
            const next = uniq(video.getAttribute('src'));
            if (next) video.setAttribute('src', next);
          }

          video.addEventListener('playing', () => {
            const item = video.closest('.cmh__media-item');
            if (item) item.classList.add('is-playing');
          });
        }

        onIntersect(entries) {
          entries.forEach((entry) => {
            if (entry.target !== this) return;
            this.inView = entry.isIntersecting;
            this.syncPlayback();
          });
        }

        onMqChange() {
          this.syncPlayback();
        }

        onPrev() {
          this.goTo(this.index - 1);
          this.startAutoplay();
        }

        onNext() {
          this.goTo(this.index + 1);
          this.startAutoplay();
        }

        onDot(event) {
          const index = parseInt(event.currentTarget.getAttribute('data-cmh-dot'), 10);
          this.goTo(index);
          this.startAutoplay();
        }

        onTouchStart(event) {
          this.touchX = event.changedTouches[0].clientX;
        }

        onTouchEnd(event) {
          if (!this.slides || this.slides.length < 2) return;
          const dx = event.changedTouches[0].clientX - this.touchX;
          if (Math.abs(dx) < 40) return;
          if (dx < 0) this.onNext();
          else this.onPrev();
        }

        onBlockSelect(event) {
          const slide = event.target.closest('[data-cmh-slide]');
          if (!slide || !this.contains(slide)) return;
          const index = Array.from(this.slides).indexOf(slide);
          if (index >= 0) this.goTo(index);
          this.stopAutoplay();
        }

        goTo(index, instant) {
          if (!this.slides || !this.slides.length) return;
          const total = this.slides.length;
          this.index = ((index % total) + total) % total;
          if (this.track) {
            this.track.style.transition = instant ? 'none' : 'transform 0.45s ease';
            this.track.style.transform = 'translateX(' + this.index * -100 + '%)';
          }
          this.slides.forEach((slide, i) => {
            slide.classList.toggle('is-active', i === this.index);
          });
          this.dots.forEach((dot, i) => {
            dot.classList.toggle('is-active', i === this.index);
          });
          this.syncPlayback();
        }

        startAutoplay() {
          this.stopAutoplay();
          if (!this.autoplayMs || !this.slides || this.slides.length < 2) return;
          this.timer = window.setInterval(() => this.goTo(this.index + 1), this.autoplayMs);
        }

        stopAutoplay() {
          if (this.timer) window.clearInterval(this.timer);
          this.timer = null;
        }

        syncPlayback() {
          const isDesktop = this.mq ? this.mq.matches : true;
          this.querySelectorAll('[data-cmh-slide]').forEach((slide, i) => {
            const active = i === this.index && this.inView;
            const hasMobile = slide.querySelectorAll('[data-cmh-mobile] video').length > 0;
            slide.querySelectorAll('[data-cmh-desktop] video').forEach((video) => {
              this.setPlaying(video, active && (isDesktop || !hasMobile));
            });
            slide.querySelectorAll('[data-cmh-mobile] video').forEach((video) => {
              this.setPlaying(video, active && !isDesktop);
            });
          });
        }

        setPlaying(video, shouldPlay) {
          if (shouldPlay) {
            video.preload = 'auto';
            video.removeAttribute('loading');
            const play = () => {
              const playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(() => {});
              }
            };
            if (video.readyState >= 2) {
              play();
            } else {
              video.addEventListener('canplay', play, { once: true });
              try {
                video.load();
              } catch (err) {}
              play();
            }
          } else {
            video.pause();
          }
        }

        onMuteClick() {
          const videos = this.querySelectorAll('video');
          if (!videos.length) return;
          const muted = !videos[0].muted;
          videos.forEach((video) => {
            video.muted = muted;
          });
          this.classList.toggle('is-unmuted', !muted);
          this.querySelectorAll('[data-cmh-mute]').forEach((btn) => {
            const label = muted ? btn.getAttribute('data-label-unmute') : btn.getAttribute('data-label-mute');
            if (label) btn.setAttribute('aria-label', label);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kids-gift-finder"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('kids-gift-finder'))customElements.define('kids-gift-finder',class extends HTMLElement{connectedCallback(){if(this.initialized)return;this.initialized=true;const form=this.querySelector('form'),interest=this.querySelector('[data-gift-interest]');const sync=()=>{if(interest.value)form.action=interest.value};interest.addEventListener('change',sync);form.addEventListener('submit',sync)}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-machine"]) return;
  try {
    
  class MachinePdpGallery extends HTMLElement {
    connectedCallback() {
      this.heroImg = this.querySelector('[data-machine-hero-img]');
      this.blurImg = this.querySelector('[data-machine-blur]');
      this.thumbs = Array.from(this.querySelectorAll('[data-machine-thumb]'));
      this.lightbox = this.querySelector('[data-machine-lightbox]');
      this.lightboxImg = this.querySelector('[data-machine-lightbox-img]');
      this.countEl = this.querySelector('[data-machine-count]');
      this.index = 0;
      this.didSwipe = false;

      this.querySelector('[data-machine-open]')?.addEventListener('click', (event) => {
        if (this.didSwipe) {
          event.preventDefault();
          this.didSwipe = false;
          return;
        }
        this.open();
      });
      this.querySelector('[data-machine-close]')?.addEventListener('click', () => this.close());
      this.querySelector('[data-machine-prev]')?.addEventListener('click', () => this.step(-1));
      this.querySelector('[data-machine-next]')?.addEventListener('click', () => this.step(1));
      this.querySelector('[data-machine-hero-prev]')?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.step(-1);
      });
      this.querySelector('[data-machine-hero-next]')?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.step(1);
      });

      const thumbsList = this.querySelector('[data-machine-thumbs]');
      this.querySelector('[data-machine-thumbs-prev]')?.addEventListener('click', () => {
        thumbsList?.scrollBy({ left: -220, behavior: 'smooth' });
      });
      this.querySelector('[data-machine-thumbs-next]')?.addEventListener('click', () => {
        thumbsList?.scrollBy({ left: 220, behavior: 'smooth' });
      });

      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => this.activate(index));
        thumb.addEventListener('mouseenter', () => {
          if (window.matchMedia('(hover: hover)').matches) this.activate(index);
        });
      });

      this.lightbox?.addEventListener('click', (event) => {
        if (event.target === this.lightbox) this.close();
      });

      this.bindSwipe();
      document.addEventListener('keydown', this.onKey);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
    }

    onKey = (event) => {
      if (!this.lightbox?.open) return;
      if (event.key === 'ArrowRight') this.step(1);
      if (event.key === 'ArrowLeft') this.step(-1);
    };

    bindSwipe() {
      const hero = this.querySelector('[data-machine-open]');
      if (!hero || this.thumbs.length < 2) return;
      let startX = 0;
      let startY = 0;

      hero.addEventListener('touchstart', (event) => {
        startX = event.changedTouches[0].clientX;
        startY = event.changedTouches[0].clientY;
        this.didSwipe = false;
      }, { passive: true });

      hero.addEventListener('touchend', (event) => {
        const dx = event.changedTouches[0].clientX - startX;
        const dy = event.changedTouches[0].clientY - startY;
        if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy)) return;
        this.didSwipe = true;
        this.step(dx < 0 ? 1 : -1);
      }, { passive: true });
    }

    activate(index) {
      const thumb = this.thumbs[index];
      if (!thumb || !this.heroImg) return;
      this.index = index;
      const src = thumb.getAttribute('data-hero-src');
      const srcset = thumb.getAttribute('data-hero-srcset');
      const blur = thumb.getAttribute('data-blur-src');
      const full = thumb.getAttribute('data-full-src');
      if (src) this.heroImg.setAttribute('src', src);
      if (srcset) this.heroImg.setAttribute('srcset', srcset);
      if (this.blurImg && blur) this.blurImg.setAttribute('src', blur);
      if (this.lightboxImg && full) this.lightboxImg.setAttribute('src', full);
      this.thumbs.forEach((item, itemIndex) => {
        const active = itemIndex === index;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (this.countEl) {
        this.countEl.textContent = (index + 1) + ' / ' + this.thumbs.length;
      }
      if (window.matchMedia('(hover: none)').matches) {
        thumb.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      }
    }

    step(delta) {
      if (this.thumbs.length === 0) return;
      const next = (this.index + delta + this.thumbs.length) % this.thumbs.length;
      this.activate(next);
    }

    open() {
      this.lightbox?.showModal();
    }

    close() {
      this.lightbox?.close();
    }
  }

  if (!customElements.get('machine-pdp-gallery')) {
    customElements.define('machine-pdp-gallery', MachinePdpGallery);
  }

  const initEnquireModal = () => {
    const enquireModal = document.getElementById('machine-enquire');
    if (!enquireModal) return;
    const shouldOpen = window.location.search.indexOf('enquire_posted') !== -1
      || enquireModal.querySelector('.errors, .form__errors, .alert');
    if (!shouldOpen) return;
    const openEnquire = () => enquireModal.open();
    if (customElements.get('modal-dialog')) {
      openEnquire();
    } else {
      customElements.whenDefined('modal-dialog').then(openEnquire);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEnquireModal);
  } else {
    initEnquireModal();
  }

  const initVariantPickers = () => {
    document.querySelectorAll('[data-machine-variant-picker]').forEach((picker) => {
      const variantsScript = picker.querySelector('[data-machine-variants-json]');
      if (!variantsScript) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (error) {
        return;
      }

      const root = picker.closest('.main-machine') || picker.closest('.shopify-section') || document;

      const getSelectedOptions = () =>
        Array.from(picker.querySelectorAll('.machine-pdp__option')).map((group) => {
          const checked = group.querySelector('input[type="radio"]:checked');
          return checked ? checked.value : null;
        });

      const findVariant = (opts) =>
        variants.find((variant) => opts.every((opt, index) => opt === null || variant.options[index] === opt)) || null;

      const updatePage = (variant) => {
        if (!variant) return;

        root.querySelectorAll('form.js-product-form input[name="id"]').forEach((input) => {
          input.value = String(variant.id);
        });

        root.querySelectorAll('button[name="add"]').forEach((btn) => {
          btn.disabled = !variant.available;
          const textEl = btn.querySelector('.machine-btn-text');
          const addText = btn.dataset.addText;
          const unavailText = btn.dataset.unavailText;
          if (textEl && addText && unavailText) {
            textEl.textContent = variant.available ? addText : unavailText;
          }
        });

        const fromEl = root.querySelector('[data-machine-price-from]');
        if (fromEl) fromEl.hidden = true;

        const priceValueEl = root.querySelector('[data-machine-price-value]');
        if (priceValueEl && variant.price_money) {
          priceValueEl.textContent = variant.price_money;
        }

        const onSale = Number(variant.compare_at_price) > Number(variant.price) && Number(variant.price) > 0;
        const priceEl = root.querySelector('[data-machine-price]');
        if (priceEl) priceEl.classList.toggle('machine-card__price--sale', onSale);

        const wasEl = root.querySelector('[data-machine-price-was]');
        const wasValueEl = root.querySelector('[data-machine-price-was-value]');
        if (wasEl && wasValueEl) {
          if (onSale && variant.compare_at_price_money) {
            wasValueEl.textContent = variant.compare_at_price_money;
            wasEl.hidden = false;
          } else {
            wasEl.hidden = true;
          }
        }

        const priceLabelEl = root.querySelector('[data-machine-price-label]');
        if (priceLabelEl) {
          priceLabelEl.textContent = onSale ? priceLabelEl.dataset.saleLabel : priceLabelEl.dataset.regularLabel;
        }

        const reducedEl = root.querySelector('[data-machine-reduced]');
        if (reducedEl) reducedEl.hidden = !onSale;

        const skuEl = root.querySelector('[data-machine-sku]');
        if (skuEl) {
          if (variant.sku) {
            const tpl = skuEl.dataset.refTpl || '___SKU___';
            skuEl.textContent = tpl.replace('___SKU___', variant.sku);
            skuEl.style.display = '';
          } else {
            skuEl.style.display = 'none';
          }
        }

        const formSkuInput = document.querySelector('input[name="contact[SKU]"]');
        if (formSkuInput) formSkuInput.value = variant.sku || '';

        const selectedOpts = getSelectedOptions();
        picker.querySelectorAll('.machine-pdp__option').forEach((group, groupIndex) => {
          group.querySelectorAll('input[type="radio"]').forEach((radio) => {
            const testOpts = selectedOpts.slice();
            testOpts[groupIndex] = radio.value;
            const anyAvail = variants.some(
              (candidate) =>
                candidate.available &&
                testOpts.every((opt, index) => opt === null || candidate.options[index] === opt)
            );
            radio.classList.toggle('is-unavailable', !anyAvail);
          });
        });
      };

      picker.addEventListener('change', (event) => {
        if (!event.target.matches('input[type="radio"]')) return;
        updatePage(findVariant(getSelectedOptions()));
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantPickers);
  } else {
    initVariantPickers();
  }

  const openMachineAccordionFromHash = () => {
    const hash = window.location.hash;
    if (!hash) return;
    const root = document.querySelector(hash);
    if (!root || !root.classList.contains('machine-pdp__module')) return;
    const details = root.querySelector('details.disclosure');
    if (details) details.open = true;
  };

  const initMachineAccordions = () => {
    openMachineAccordionFromHash();
    document.querySelectorAll('.machine-pdp__module--accordion details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        window.dispatchEvent(new Event('resize'));
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMachineAccordions);
  } else {
    initMachineAccordions();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sale"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('product-sale')) {
  class ProductSale extends HTMLElement {
    connectedCallback() {
      this.variantSelect = this.querySelector('[data-product-sale-variant]');
      this.idInput = this.querySelector('[name="id"]');
      this.submitBtn = this.querySelector('[name="add"]');
      if (!this.variantSelect || !this.idInput) return;
      this.variantSelect.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange() {
      const variantId = this.variantSelect.value;
      this.idInput.value = variantId;

      this.querySelectorAll('[data-variant-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.variantPanel !== variantId;
      });

      this.querySelectorAll('.product-sale__heading-badge-panel[data-variant-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.variantPanel !== variantId;
      });

      const option = this.variantSelect.selectedOptions[0];
      if (!this.submitBtn || !option) return;

      const available = option.dataset.available === 'true';
      this.submitBtn.disabled = !available;
      this.submitBtn.textContent = available
        ? this.submitBtn.dataset.addToCartText
        : this.submitBtn.dataset.soldOutText;
    }
  }

  customElements.define('product-sale', ProductSale);
}

  } catch(e) { console.error(e); }
})();
})();
